
    <span class="popover-wrapper">
      <span (click)="enabled && toggle()">
        <ng-content select="cm-popover-action">
      </ng-content>
      </span>
      <span class="popover" [class.opened]="opened">
        <ng-content select="cm-popover-content"></ng-content>
      </span>
    </span>
  